module.exports = __webpack_public_path__ + "img/isologo.25a7f457.png";